var map = {
	"./rijeka/potential1.jpg": 4076,
	"./rijeka/potential2.jpg": 7290,
	"./rijeka/potential3.jpg": 9368,
	"./rijeka/potential4.mp4": 6266,
	"./rijeka/potential5.jpg": 3749,
	"./rijeka/potential6.jpg": 5708,
	"./rijeka/rijeka.mp4": 6961,
	"./solin/potential1.jpg": 9267,
	"./solin/potential2.jpg": 8925,
	"./solin/potential3.mp4": 1700,
	"./solin/potential4.jpg": 1372,
	"./solin/potential5.jpg": 5798,
	"./solin/potential6.jpg": 1818,
	"./solin/potential7.jpg": 753,
	"./solin/solin.mp4": 9295
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5036;